import {Component, EventEmitter, Output} from '@angular/core';

@Component({
    selector: 'app-register-company-congratulations',
    templateUrl: './congratulations-step.component.html',
    styleUrls: ['../../register-company.component.scss']
})
export class RegisterCompanyCongratulationsStepComponent {

    @Output() goToLogin = new EventEmitter<void>();

    backToLogin(): void {
        this.goToLogin.emit();
    }
}
